import { IStockTakeFinalFigure, IStockTakeItemDetail, StockTakeItemStatus } from '../models';

/**
 * Maps stored final figures into the item-detail shape used by the process confirmation modal.
 */
export function mapFinalFiguresToConfirmModalItems(
  figures: IStockTakeFinalFigure[],
): IStockTakeItemDetail[] {
  return figures.map((figure: IStockTakeFinalFigure): IStockTakeItemDetail => ({
    code: figure.code,
    id: figure.id || figure.code,
    delColMovement: figure.delColMovement ?? 0,
    delColQty: figure.delColQty ?? 0,
    description: figure.description ?? '',
    latestCost: figure.latestCost ?? 0,
    movement: figure.movement ?? 0,
    onhand: figure.onhand ?? 0,
    previousQtyCounted: 0,
    qtyCounted: figure.qtyCounted ?? 0,
    randVariance: figure.randVariance ?? 0,
    status: StockTakeItemStatus.counted,
    timesCounted: figure.timesCounted ?? 0,
    variance: figure.variance ?? figure.varianceQty ?? 0,
    avCost: figure.avCost,
    binLocation: figure.binLocation,
    countedByEmail: figure.countedByEmail,
  }));
}
